import type { Page, AppData } from "../types";

/**
 * Sets the document title based on page data and config
 * @param pageData - The current page data (optional)
 * @param appData - The app data containing config
 */
export const setPageTitle = (pageData: Page | null, appData: AppData | null): void => {
  const baseTitle = appData?.config?.pageTitle || "";
  
  if (pageData?.title && baseTitle) {
    document.title = `${pageData.title} - ${baseTitle}`;
  } else if (pageData?.title) {
    document.title = pageData.title === '/' ? 'Бэлэн Бай' : pageData.title;
  } else if (baseTitle) {
    document.title = baseTitle;
  } else {
    document.title = "Бэлэн Бай"; // Fallback title
  }
};

/**
 * Sets the document title with a custom title
 * @param title - Custom title string
 * @param appData - The app data containing config (optional)
 */
export const setCustomPageTitle = (title: string, appData: AppData | null = null): void => {
  const baseTitle = appData?.config?.pageTitle || "";
  
  if (baseTitle) {
    document.title = `${title} - ${baseTitle}`;
  } else {
    document.title = title;
  }
};

